// client/src/utils/pdfGenerator.js
import React from 'react';

// Safe stub: returns a basic PDF-like blob so pages depending on this do not crash.
export async function generatePdf(_data) {
  const content = `PDF generation is not yet implemented.\nTimestamp: ${new Date().toISOString()}`;
  return new Blob([content], { type: 'application/pdf' });
}

// Minimal placeholder for PDFTemplate usage in components.
// Implement as a valid React function component so it can be rendered safely.
export function PDFTemplate(props) {
  const { title = 'PDF Template Preview (stub)', children } = props || {};
  return (
    <div style={{ padding: 12, border: '1px dashed #999', borderRadius: 6 }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 12, color: '#666' }}>
        {children || 'Rendering placeholder. Connect real template engine to replace this.'}
      </div>
    </div>
  );
}